export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const filePath = node.data.path || ''
  const fileName = node.data.filename || ''

  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false  

  let html = ''

  if (! filePath && ! fileName) {
    $('#hover-node-card .card-body').html('')
  } else {
    const imgSource = 'https://192.168.10.60/xerochat/' + filePath + fileName
    html += `<p><img class="img-fluid" src="${imgSource}" /></p>`

    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    }

    $('#hover-node-card .card-body').html(html)
  }  
}